import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=4f6cb5ce&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6cb5ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f6cb5ce')) {
      api.createRecord('4f6cb5ce', component.options)
    } else {
      api.reload('4f6cb5ce', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=4f6cb5ce&scoped=true&", function () {
      api.rerender('4f6cb5ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-83lxCq9rDfx75/JS/comp/Accordion.vue"
export default component.exports